console.log("SCRIPT_LOAD: drawercart2.js");

if (typeof Shopify === "undefined") {
  window.Shopify = {};
}

if (typeof Shopify.getCart === "undefined") {
  Shopify.getCart = function(callback, data) {
    if (!data) {
      return jQuery.getJSON("/cart.js", function(cart, status, xhr) {
        if (typeof callback === "function") {
          callback(cart, status, xhr);
        } else {
          Shopify.onCartUpdate(cart);
        }
      });
    }
    if (typeof callback === "function") {
      callback(data);
    } else if (typeof Shopify.onCartUpdate === "function") {
      Shopify.onCartUpdate(data);
    }
  };
}

var Shopify = Shopify || {};
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, formatString) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }

  var value = "",
      placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
      formatString = formatString || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt === "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    if (isNaN(number) || number == null) {
      return "0";
    }

    // apply defaults
    thousands = defaultOption(thousands, ",");
    decimal   = defaultOption(decimal, ".");

    var parts = (number / 100).toFixed(defaultOption(precision, 2)).split(".");

    var dollars = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      "$1" + thousands
    );

    var cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents,                2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents,                0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents,                2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents,                0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

class GoCart {
  constructor(options) {
    this.defaults = Object.assign({
      cartModalFail: ".js-go-cart-modal-fail",
      cartModalFailClose: ".js-go-cart-modal-fail-close",
      cartModal: ".js-go-cart-modal",
      cartModalClose: ".js-go-cart-modal-close",
      cartModalContent: ".js-go-cart-modal-content",
      cartDrawer: ".js-go-cart-drawer",
      cartDrawerContent: ".js-go-cart-drawer-content",
      cartDrawerSubTotal: ".js-go-cart-drawer-subtotal",
      cartDrawerFooter: ".js-go-cart-drawer-footer",
      cartDrawerClose: ".js-go-cart-drawer-close",
      cartMiniCart: ".js-go-cart-mini-cart",
      cartMiniCartContent: ".js-go-cart-mini-cart-content",
      cartMiniCartSubTotal: ".js-go-cart-mini-cart-subtotal",
      cartMiniCartFooter: ".js-go-cart-mini-cart-footer",
      cartTrigger: ".js-go-cart-trigger",
      cartOverlay: ".js-go-cart-overlay",
      cartCount: ".js-go-cart-counter",
      addToCart: ".js-go-cart-add-to-cart",
      removeFromCart: ".js-go-cart-remove-from-cart",
      removeFromCartNoDot: "js-go-cart-remove-from-cart",
      itemQuantity: ".js-go-cart-quantity",
      itemQuantityPlus: ".js-go-cart-quantity-plus",
      itemQuantityMinus: ".js-go-cart-quantity-minus",
      cartMode: "drawer",
      drawerDirection: "right",
      displayModal: false,
      moneyFormat: "${{amount}}",
      labelAddedToCart: "was added to your cart.",
      labelCartIsEmpty: "Your Cart is currently empty!",
      labelQuantity: "Quantity:",
      labelRemove: "Remove"
    }, options);

    // Cache DOM elements
    this.cartModalFail      = document.querySelector(this.defaults.cartModalFail);
    this.cartModalFailClose = document.querySelector(this.defaults.cartModalFailClose);
    this.cartModal          = document.querySelector(this.defaults.cartModal);
    this.cartModalClose     = document.querySelectorAll(this.defaults.cartModalClose);
    this.cartModalContent   = document.querySelector(this.defaults.cartModalContent);
    this.cartDrawer         = document.querySelector(this.defaults.cartDrawer);
    this.cartDrawerContent  = document.querySelector(this.defaults.cartDrawerContent);
    this.cartDrawerSubTotal = document.querySelector(this.defaults.cartDrawerSubTotal);
    this.cartDrawerFooter   = document.querySelector(this.defaults.cartDrawerFooter);
    this.cartDrawerClose    = document.querySelector(this.defaults.cartDrawerClose);
    this.cartMiniCart       = document.querySelector(this.defaults.cartMiniCart);
    this.cartMiniCartContent= document.querySelector(this.defaults.cartMiniCartContent);
    this.cartMiniCartSubTotal = document.querySelector(this.defaults.cartMiniCartSubTotal);
    this.cartMiniCartFooter = document.querySelector(this.defaults.cartMiniCartFooter);
    this.cartTrigger        = document.querySelectorAll(this.defaults.cartTrigger);
    this.cartOverlay        = document.querySelector(this.defaults.cartOverlay);
    this.cartCount          = document.querySelector(this.defaults.cartCount);
    this.addToCart          = document.querySelectorAll(this.defaults.addToCart);
    this.removeFromCart     = this.defaults.removeFromCart;
    this.removeFromCartNoDot= this.defaults.removeFromCartNoDot;
    this.itemQuantity       = this.defaults.itemQuantity;
    this.itemQuantityPlus   = this.defaults.itemQuantityPlus;
    this.itemQuantityMinus  = this.defaults.itemQuantityMinus;
    this.cartMode           = this.defaults.cartMode;
    this.drawerDirection    = this.defaults.drawerDirection;
    this.displayModal       = this.defaults.displayModal;
    this.moneyFormat        = this.defaults.moneyFormat;
    this.labelAddedToCart   = this.defaults.labelAddedToCart;
    this.labelCartIsEmpty   = this.defaults.labelCartIsEmpty;
    this.labelQuantity      = this.defaults.labelQuantity;
    this.labelRemove        = this.defaults.labelRemove;

    this.init();
  }

  get isDrawerMode() {
    return this.cartMode === "drawer";
  }

  init() {
    this.fetchCart();

    if (this.isDrawerMode) {
      this.setDrawerDirection();
    } else {
      document.querySelector(".go-cart-wrp").classList.add("mini-cart");
    }

    // Add to cart handler
    document.addEventListener("click", (evt) => {
      if (evt.target.matches(this.defaults.addToCart)) {
        evt.preventDefault();
        let formEl = evt.target.closest("form");
        const formId = formEl.getAttribute("id");
        const variantInput = document.querySelector("#curentvariant");
        const qtyInput = document.querySelector('input[name="quantity"]');
        const desiredQty = parseInt(qtyInput.value, 10);
        const available = parseInt(document.querySelector(".inventoryNote").textContent, 10);

        if (!available || desiredQty <= available) {
          // check existing lines & free-gift logic...
          this.addItemToCart(formId);
        }
      }
    }, false);

    // Cart trigger (drawer/mini)
    this.cartTrigger.forEach(btn => {
      btn.addEventListener("click", () => {
        if (this.isDrawerMode) {
          this.openCartDrawer();
        } else {
          this.openMiniCart();
        }
        this.openCartOverlay();
      });
    });

    // Overlay close
    this.cartOverlay.addEventListener("click", () => {
      this.closeCartModal();
      if (this.isDrawerMode) this.closeCartDrawer(); else this.closeMiniCart();
      this.closeCartOverlay();
    });

    // Drawer close
    if (this.isDrawerMode && this.cartDrawerClose) {
      this.cartDrawerClose.addEventListener("click", () => {
        this.closeCartDrawer();
        this.closeCartOverlay();
      });
    }

    // Modal close buttons
    if (this.displayModal) {
      this.cartModalClose.forEach(el => {
        el.addEventListener("click", () => {
          this.closeCartModal();
          if (this.isDrawerMode) this.closeCartDrawer(); else this.closeMiniCart();
          this.closeCartOverlay();
        });
      });
    }

    // Fail modal close
    if (this.cartModalFailClose) {
      this.cartModalFailClose.addEventListener("click", () => {
        this.closeCartModal();
        if (this.isDrawerMode) this.closeCartDrawer(); else this.closeMiniCart();
        this.closeCartOverlay();
      });
    }
  }

  fetchCart(callback) {
    fetch("/cart.js", { credentials: "same-origin", method: "GET" })
      .then(r => r.json())
      .then(cart => this.fetchHandler(cart, callback))
      .catch(err => { this.ajaxRequestFail(); throw err; });
  }

  addItemToCart(formId) {
    Shopify.getCart(function(cart) {
      const form = document.querySelector(`#${formId}`);
      // Build body from form...
      setTimeout(() => {
        fetch("/cart/add.js", {
          method: "POST",
          credentials: "include",
          headers: {"Content-Type": "application/x-www-form-urlencoded"},
          body: new URLSearchParams(new FormData(form)).toString()
        })
        .then(r => r.json())
        .then(() => Shopify.getCart((updatedCart) => {
          this.addItemToCartHandler(updatedCart);
        }))
        .catch(err => { this.ajaxRequestFail(); throw err; });
      }, 2500);
    }.bind(this));
  }

  removeItem(line) {
    Shopify.getCart(function() {
      fetch("/cart/change.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({ line: line, quantity: 0 })
      })
      .then(r => r.json())
      .then(() => this.fetchCart())
      .catch(err => { this.ajaxRequestFail(); throw err; });
    }.bind(this));
  }

  changeItemQuantity(line, qty, freeLinePrice) {
    Shopify.getCart(function() {
      fetch("/cart/change.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({ line: line, quantity: qty })
      })
      .then(r => r.json())
      .then(() => this.fetchCart())
      .catch(err => { this.ajaxRequestFail(); throw err; });
    }.bind(this));
  }

  cartItemCount(cart) {
    document.querySelectorAll(".js-go-cart-counter")
      .forEach(el => el.innerHTML = cart.item_count);
  }

  fetchAndOpenCart() {
    this.fetchCart(() => {
      if (this.isDrawerMode) this.openCartDrawer(); else this.openMiniCart();
      this.openCartOverlay();
    });
  }

  fetchAndOpenModal(item) {
    this.fetchCart(() => {
      this.renderCartModal(item);
      this.openCartModal();
      this.openCartOverlay();
    });
  }

  fetchHandler(cart, callback) {
    this.cartItemCount(cart);

    if (this.isDrawerMode) {
      if (cart.item_count === 0) {
        this.renderBlankCartDrawer();
        this.cartDrawerFooter.classList.add("is-invisible");
      } else {
        this.renderDrawerCart(cart);
        this.cartDrawerFooter.classList.remove("is-invisible");
        if (typeof callback === "function") callback(cart);
      }
    } else {
      if (cart.item_count === 0) {
        this.renderBlankMiniCart();
        this.cartMiniCartFooter.classList.add("is-invisible");
      } else {
        this.renderMiniCart(cart);
        this.cartMiniCartFooter.classList.remove("is-invisible");
        if (typeof callback === "function") callback(cart);
      }
    }
  }

  addItemToCartHandler(item) {
    if (this.displayModal) {
      this.fetchAndOpenModal(item);
    } else {
      this.fetchAndOpenCart();
    }
  }

  ajaxRequestFail() {
    // handle AJAX failure if needed
  }

  renderCartModal(item) {
    this.clearCartModal();
    const variantText = item.variant_title ? `(${item.variant_title})` : "";
    const imgUrl = item.image || "";
    this.cartModalContent.innerHTML += `
      <div class="go-cart-modal-item">
        <div class="go-cart-item__image" style="background-image:url(${imgUrl});"></div>
        <div class="go-cart-item__info">
          <a href="${item.url}" class="go-cart-item__title">
            ${item.product_title} ${variantText}
          </a> ${this.labelAddedToCart}
        </div>
      </div>
    `;
  }

  renderDrawerCart(cart) {
    this.clearCartDrawer();

    cart.items.forEach((item, index) => {
      // compute prices
      const currentLinePriceCents  = item.line_price;
      const originalLinePriceCents = item.original_price * item.quantity;
      const formattedCurrent       = Shopify.formatMoney(currentLinePriceCents,  this.moneyFormat);
      const formattedOriginal      = Shopify.formatMoney(originalLinePriceCents, this.moneyFormat);
      const showOriginal           = originalLinePriceCents > currentLinePriceCents;

      const title        = item.product_title;
      const variantTitle = item.variant_title || "";
      const imgUrlRaw    = item.image || "";
      const imgUrl       = imgUrlRaw.replace(/(\.png|\.jpe?g|\.webp)$/, `_200x320$1`);

      // free‑gift logic
      const isFree = title.toLowerCase().startsWith("free");
      const displayPriceHtml = isFree
        ? '<div class="go-cart-item__price h5 m0">FREE</div>'
        : `
          
          ${showOriginal ? `<div class="go-cart-item__price--original h6 m0"><s>${formattedOriginal}</s></div>` : ""}
          <div class="go-cart-item__price h5 m0">${formattedCurrent}</div>
          <div class="go-cart-item__quantity">
            <span class="go-cart-item__quantity-label">${this.labelQuantity}</span>
            <span class="go-cart-item__quantity-button js-go-cart-quantity-minus">-</span>
            <input class="go-cart-item__quantity-number js-go-cart-quantity"
                   type="number"
                   data-quantityid="${item.id}"
                   value="${item.quantity}"
                   disabled>
            <span class="go-cart-item__quantity-button js-go-cart-quantity-plus">+</span>
          </div>
        `;

      const itemHtml = `
        <div class="go-cart-item__single" data-line="${index+1}" data-id="${item.id}" data-handle="${item.handle}">
          <div class="go-cart-item__info-wrapper">
            <div class="go-cart-item__image" style="background-image:url(${imgUrl});"></div>
            <div class="go-cart-item__info">
              <div class="go-cart-item__wrp">
                ${isFree
                  ? `<span class="go-cart-item__title_free fw_600 h6 mt0 mb10">${title}</span>`
                  : `<a href="${item.url}" class="go-cart-item__title fw_600 h6 mt0 mb10">${title}</a>`
                }
                ${variantTitle ? `<div class="go-cart-item__variant fw_600 caps mt0 mb10">${variantTitle}</div>` : ""}
                <div class="remove-link fw_600 caps mt26">
                  <span class="js-go-cart-remove-from-cart">${this.labelRemove}</span>
                </div>
              </div>
              <div class="quantity-wrp mb10">
                ${displayPriceHtml}
              </div>
            </div>
          </div>
        </div>
      `;

      this.cartDrawerContent.innerHTML += itemHtml;
    });

    // update subtotal
    let freeAmount = 0;
    cart.items.forEach(item => {
      if (item.product_title.toLowerCase().startsWith("free")) {
        freeAmount += item.line_price;
      }
    });
    let subtotal = cart.total_price - freeAmount;
    this.cartDrawerSubTotal.innerHTML = Shopify.formatMoney(subtotal, this.moneyFormat);
    this.cartDrawerSubTotal.parentNode.classList.remove("is-invisible");

    // bind remove & quantity buttons
    document.querySelectorAll(this.removeFromCart).forEach(el => {
      el.addEventListener("click", () => {
        const line = el.closest(".go-cart-item__single").getAttribute("data-line");
        GoCart.removeItemAnimation(el.closest(".go-cart-item__single"));
        this.removeItem(line);
      });
    });
    document.querySelectorAll(this.itemQuantityPlus).forEach(el => {
      el.addEventListener("click", () => {
        const line = el.closest(".go-cart-item__single").getAttribute("data-line");
        const qty  = Number(el.closest(".go-cart-item__single").querySelector(this.itemQuantity).value) + 1;
        this.changeItemQuantity(line, qty, 0);
      });
    });
    document.querySelectorAll(this.itemQuantityMinus).forEach(el => {
      el.addEventListener("click", () => {
        const wrapper = el.closest(".go-cart-item__single");
        const line = wrapper.getAttribute("data-line");
        const currentQty = Number(wrapper.querySelector(this.itemQuantity).value);
        const newQty = currentQty - 1;
        if (newQty <= 0) {
          GoCart.removeItemAnimation(wrapper);
        }
        this.changeItemQuantity(line, newQty, 0);
      });
    });

    // run any tag-based UI updates
    getTagFirstMonthFree();
  }

  renderMiniCart(cart) {
    this.clearMiniCart();
    cart.items.forEach((item, index) => {
      const formattedLine = Shopify.formatMoney(item.line_price, this.moneyFormat);
      this.cartMiniCartContent.innerHTML += `
        <div class="go-cart-item__single" data-line="${index+1}" data-id="${item.id}">
          <div class="go-cart-item__info-wrapper">
            <div class="go-cart-item__image" style="background-image:url(${item.image});"></div>
            <div class="go-cart-item__info">
              <a href="${item.url}" class="go-cart-item__title">${item.product_title}</a>
              <div class="go-cart-item__price">${formattedLine}</div>
              <div class="go-cart-item__quantity">
                <span class="go-cart-item__quantity-label">${this.labelQuantity}</span>
                <span class="go-cart-item__quantity-button js-go-cart-quantity-minus">-</span>
                <input class="go-cart-item__quantity-number js-go-cart-quantity"
                       type="number"
                       data-quantityid="${item.id}"
                       value="${item.quantity}"
                       disabled>
                <span class="go-cart-item__quantity-button js-go-cart-quantity-plus">+</span>
              </div>
            </div>
            <a class="go-cart-item__remove ${this.removeFromCartNoDot}">${this.labelRemove}</a>
          </div>
        </div>
      `;
    });
    this.cartMiniCartSubTotal.innerHTML = Shopify.formatMoney(cart.total_price, this.moneyFormat);
    this.cartMiniCartSubTotal.parentNode.classList.remove("is-invisible");

    document.querySelectorAll(this.removeFromCart).forEach(el => {
      el.addEventListener("click", () => {
        const line = el.closest(".go-cart-item__single").getAttribute("data-line");
        GoCart.removeItemAnimation(el.closest(".go-cart-item__single"));
        this.removeItem(line);
      });
    });
    document.querySelectorAll(this.itemQuantityPlus).forEach(el => {
      el.addEventListener("click", () => {
        const line = el.closest(".go-cart-item__single").getAttribute("data-line");
        const qty  = Number(el.closest(".go-cart-item__single").querySelector(this.itemQuantity).value) + 1;
        this.changeItemQuantity(line, qty, 0);
      });
    });
    document.querySelectorAll(this.itemQuantityMinus).forEach(el => {
      el.addEventListener("click", () => {
        const wrapper = el.closest(".go-cart-item__single");
        const line = wrapper.getAttribute("data-line");
        const newQty = Number(wrapper.querySelector(this.itemQuantity).value) - 1;
        if (newQty <= 0) {
          GoCart.removeItemAnimation(wrapper);
        }
        this.changeItemQuantity(line, newQty, 0);
      });
    });
  }

  renderBlankCartDrawer() {
    this.cartDrawerSubTotal.parentNode.classList.add("is-invisible");
    this.clearCartDrawer();
    this.cartDrawerContent.innerHTML = `<div class="go-cart__empty">${this.labelCartIsEmpty}</div>`;
  }

  renderBlankMiniCart() {
    this.cartMiniCartSubTotal.parentNode.classList.add("is-invisible");
    this.clearMiniCart();
    this.cartMiniCartContent.innerHTML = `<div class="go-cart__empty">${this.labelCartIsEmpty}</div>`;
  }

  clearCartDrawer() {
    this.cartDrawerContent.innerHTML = "";
  }

  clearMiniCart() {
    this.cartMiniCartContent.innerHTML = "";
  }

  clearCartModal() {
    this.cartModalContent.innerHTML = "";
  }

  openCartDrawer() {
    this.cartDrawer.classList.add("is-open");
    document.body.classList.add("overflow-hidden");
  }

  closeCartDrawer() {
    this.cartDrawer.classList.remove("is-open");
    document.body.classList.remove("overflow-hidden");
  }

  openMiniCart() {
    this.cartMiniCart.classList.add("is-open");
  }

  closeMiniCart() {
    this.cartMiniCart.classList.remove("is-open");
  }

  openCartModal() {
    this.cartModal.classList.add("is-open");
  }

  closeCartModal() {
    this.cartModal.classList.remove("is-open");
  }

  openCartOverlay() {
    this.cartOverlay.classList.add("is-open");
  }

  closeCartOverlay() {
    this.cartOverlay.classList.remove("is-open");
  }

  static removeItemAnimation(el) {
    el.classList.add("is-invisible");
  }

  setDrawerDirection() {
    this.cartDrawer.classList.add(`go-cart__drawer--${this.drawerDirection}`);
  }
}

// Mini-cart close button
document.querySelector(".js-go-cart-mini-cart-close")
  .addEventListener("click", function() {
    setTimeout(() => {
      document.querySelector(".js-go-cart-mini-cart").classList.remove("is-open");
      document.querySelector(".js-go-cart-overlay").classList.remove("is-open");
    }, 100);
  });

var goCart = new GoCart({ cartMode: "drawer" });

function getTagFirstMonthFree() {
  setTimeout(() => {
    document.querySelectorAll(".go-cart-item__single").forEach(el => {
      if (first_month_free.includes(el.dataset.handle)) {
        el.querySelector(".go-cart-item__wrp").classList.add("mc-fmf");
      }
      if (limit_one.includes(el.dataset.handle)) {
        el.querySelectorAll(".go-cart-item__quantity").forEach(q => q.classList.add("d-none"));
      }
      if (no_qty_adjust.includes(el.dataset.handle)) {
        el.querySelectorAll(".go-cart-item__quantity").forEach(q => q.classList.add("d-none"));
      }
    });
  }, 2000);
}

if (goCart.cartMode === "mini-cart") {
  document.querySelector(".js-go-cart-mini-cart").classList.remove("hidden");
}
getTagFirstMonthFree();

console.log("first_month_free: " + first_month_free);
console.log("limit_one: " + limit_one);
console.log("no_qty_adjust: " + no_qty_adjust);
